import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dl-icon-stack",
  "use": "dl-icon-stack-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dl-icon-stack\">\n  <path d=\"M20 4V16H22V2H8V4H20Z\" fill=\"currentColor\" />\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 8V22H16V8H2ZM14 10H4V20H14V10Z\" fill=\"currentColor\" />\n  <path d=\"M17 7H5V5H19V19H17V7Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol